import { PLAYER_COLORS, type Player } from "@poppycock/shared";
import { motion } from "framer-motion";

export function PlayerList({
  players,
  hostId,
  youId,
  showScores = false,
  lastDelta,
}: {
  players: Player[];
  hostId: string;
  youId?: string;
  showScores?: boolean;
  lastDelta?: Record<string, number>;
}) {
  const sorted = showScores
    ? [...players].sort((a, b) => b.score - a.score)
    : players;

  return (
    <ul className="flex flex-col gap-2">
      {sorted.map((p, i) => {
        const color = PLAYER_COLORS[p.colorIndex % PLAYER_COLORS.length];
        const delta = lastDelta?.[p.id] ?? 0;
        return (
          <motion.li
            key={p.id}
            layout
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.04 }}
            className={`flex items-center gap-3 rounded-xl border border-white/6 bg-black/20 px-3 py-2.5 ${
              !p.connected ? "opacity-45" : ""
            }`}
          >
            <span
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-[#141414]"
              style={{ background: color }}
            >
              {p.name.slice(0, 1).toUpperCase()}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 truncate">
                <span className="truncate font-medium">{p.name}</span>
                {p.id === youId && (
                  <span className="text-[10px] tracking-wide text-[var(--color-muted)] uppercase">
                    you
                  </span>
                )}
                {p.id === hostId && (
                  <span className="rounded bg-white/10 px-1.5 py-0.5 text-[10px] font-medium tracking-wide text-[var(--color-accent)] uppercase">
                    host
                  </span>
                )}
              </div>
              {!p.connected && (
                <span className="text-[11px] text-[var(--color-muted)]">
                  disconnected
                </span>
              )}
            </div>
            {showScores && (
              <div className="text-right">
                <div className="font-semibold tabular-nums">{p.score}</div>
                {delta > 0 && (
                  <div className="text-[11px] font-medium text-[var(--color-success)]">
                    +{delta}
                  </div>
                )}
              </div>
            )}
          </motion.li>
        );
      })}
    </ul>
  );
}
